/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { CircularProgress, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import _ from 'lodash';
import BudgetManualVoteForm from './BudgetManualVoteForm';
import { actions as budgetActions } from '../../actions/budgetActions';

class BudgetVotePage extends React.Component {
  componentDidMount() {
    this.props.actions.loadVoteFormSettings();
  }

  createFormInitialState() {
    const voterIdentificationMethodId = this.props.votingSettings.voterIdentificationMethods.length === 1
        ? this.props.votingSettings.voterIdentificationMethods[0].id
        : null;

    const voter = {};
    if (voterIdentificationMethodId) {
      const identificationMethod = this.props.votingSettings.voterIdentificationMethods.find(i => i.id === voterIdentificationMethodId);

      if (identificationMethod.voterRequiredData.address) {
        if (!identificationMethod.terytEnabled
          && !identificationMethod.streetsAutocomplete
          && identificationMethod.voterRequiredData.addressRestrictedToCities
          && identificationMethod.voterRequiredData.addressRestrictedToCities.length === 1) {
          voter.city = identificationMethod.voterRequiredData.addressRestrictedToCities[0];
        } else if (!identificationMethod.terytEnabled
          && identificationMethod.streetsAutocomplete
          && identificationMethod.voterRequiredData.addressRestrictedToCities
          && identificationMethod.voterRequiredData.addressRestrictedToCities.length === 1) {
          const data = _.uniqBy(identificationMethod.streetsAutocompleteData, s => s.cityId);
          const city = data.find(c => c.cityName === identificationMethod.voterRequiredData.addressRestrictedToCities[0]);
          if (city) {
            voter.city = city.cityName;
            voter.cityId = city.cityId;
          }
        }
      }
    }
    
    return {
      submissionDate: moment(this.props.votingSettings.votingEndDate) <= moment.utc()
        ? this.props.votingSettings.votingEndDate
        : new Date(),
      budgetId: this.props.votingSettings.id,
      voterIdentificationMethodId,
      voter,
      votes: [],
    };
  }

  submitForm = data => this.props.actions.voteManual(this.props.votingSettings.id, data);

  render() {
    const { fetching, votingSettings } = this.props;

    return (<React.Fragment>
      {fetching ? <div style={{ width: '100%', marginTop: 200, textAlign: 'center' }}><CircularProgress size={50} /></div> :
        <div key="content" style={{ marginTop: 40 }}>
          <div className="row">
            <div className="box">
              <div className="col-sm-12 text-center">
                <h2 className="box-header">{votingSettings.name} <span>Formularz głosowania</span></h2>
              </div>
            </div>
          </div>

          <BudgetManualVoteForm
            votingSettings={votingSettings}
            onSubmit={this.submitForm}
            initialValues={this.createFormInitialState()}
            disabled={this.props.manual}
            actions={this.props.actions}
          />
          <Dialog open={this.props.success && !this.props.voteError} aria-labelledby="dialog-title" maxWidth="md">
            <DialogTitle id="dialog-title">Głos został zapisany</DialogTitle>
            <DialogContent>
              <Typography variant="subtitle1">Czy chcesz wprowadzić kolejny głos?</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { window.location.reload(); }} color="primary">
                Tak
              </Button>
              <Button onClick={() => { window.location.href = 'https://' + window.location.host + '/admin/budzety/' + votingSettings.id + '/glosy/'; }}>
                Nie
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={this.props.voteError == null ? false : true} aria-labelledby="dialog-title" maxWidth="md">
            <DialogTitle id="dialog-title">Uwaga</DialogTitle>
            <DialogContent>
              {this.props.voteError === "alreadyVoted"
                ? <Typography variant="subtitle1">Wpisane dane zostały już wcześniej wykorzystane do głosowania w aktualnym Budżecie.</Typography>
                : this.props.voteError === "notVerified"
                  ? <Typography variant="subtitle1">Mieszkaniec nie został zidentyfikowany. Głos będzie ważny po potwierdzeniu tożsamości w Urzędzie.</Typography>
                  : <Typography variant="subtitle1">Wystąpił problem podczas oddawania głosu. Upewnij się, że wybrałeś co najmniej jeden projekt.</Typography>
              }
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { window.location.href = 'https://' + window.location.host + '/admin/budzety/' + votingSettings.id + '/glosy/'; }} color="primary" variant="contained">
                Ok
            </Button>
            </DialogActions>
          </Dialog>
        </div>}
    </React.Fragment>);
  }
}

BudgetVotePage.defaultProps = {
  success: false,
};

BudgetVotePage.propTypes = {
  budgetVoteForm: PropTypes.object,
  actions: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired,
  votingSettings: PropTypes.object,
  manual: PropTypes.bool,
  cms: PropTypes.object.isRequired,
  success: PropTypes.bool,
  voteError: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    success: state.budgetVoting.success,
    voteError: state.budgetVoting.voteError,
    fetching: state.budgetVoting.fetching,
    votingSettings: state.budgetVoting.data,
    manual: window.location.href.includes('manual'),
    cms: state.cms,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(budgetActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetVotePage);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetManualVotePage.js